export let addtodo=(todo)=>{
    return{
        type:"addtodo",
        payload:todo
    }
}

export let edittodo =(edittodo)=>{
    return{
        type:"edittodo",
        payload:edittodo
    }
}

export let deletetodo =(deletetodo)=>{
    return{
        type:"deletetodo",
        payload:deletetodo
    }
}